import { styled } from 'linaria/react';

import { FONTS, COLORS } from '../../styles/constants';

const StyledWrap = styled.div<{ isDark: boolean }>`
  z-index: 0;
  position: relative;
  margin: 0 auto;
  width: 100%;
  font-family: ${FONTS.primary};
  font-size: 16px;
  color: ${({ isDark }) => (isDark ? COLORS.white[100] : COLORS.brown.dark[100])};
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  background: ${({ isDark }) =>
    isDark
      ? 'linear-gradient(180deg, #331500 0%, #141400 10%, #141400 90%, #0A0033 100%)'
      : 'linear-gradient(180deg, #FFEEE8 0%, #F7F6F3 10%, #F7F6F3 90%, #ECE8FF 100%), #FFF'};
`;

export const StyledVirtualBg = styled.div<{ isDark?: boolean; isDiscovery?: boolean; gradientEnd?: string | null }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100dvh;
  background: ${({ isDark, isDiscovery, gradientEnd }) => {
    if (isDiscovery) {
      return isDark
        ? 'linear-gradient(180deg, #331500 0%, #141400 10%, #141400 90%, #0A0033 100%)'
        : 'linear-gradient(180deg, #FFEEE8 0%, #F7F6F3 10%, #F7F6F3 90%, #ECE8FF 100%), #FFF';
    }
    // For profile view, align with ProfileTop/ListGrid base color logic
    return gradientEnd ?? (isDark ? COLORS.black[100] : COLORS.white[100]);
  }};
  z-index: -1;
  user-select: none;
  pointer-events: none;
  transition: background 0.5s ease, background-color 0.5s ease;
`;

export const MainContent = styled.main<{ isDiscovery?: boolean; isSavedPicks?: boolean }>`
  padding-top: ${({ isDiscovery, isSavedPicks }) => {
    if (isSavedPicks) {
      return '60px';
    }
    if (isDiscovery) {
      return '222px';
    }
    return '0';
  }};
`;

export default StyledWrap;
